import { environment } from 'src/environments/environment';

/**
 * Imagem do cardápio no tamanho em que aparece.
 *
 * O servidor de imagens (`imgURL`) só tem JPEG em tamanhos fixos: o logo chega a 3977 px para ser
 * exibido em 50 (pastel.com: 408 KB), e na página do SSR as imagens eram 65% dos bytes. O stack
 * `aws-sam-imagens` serve `imgVariantURL/v/<largura>/<caminho>.webp`: a versão é gerada uma vez na
 * primeira requisição e guardada. Nunca amplia — pedir 240 de uma `thumb_` de 200 px devolve 200.
 *
 * `imgVariantURL` vazio (todo ambiente que ainda não ligou) = o JPEG original, exatamente como antes.
 *
 * Se a versão falhar (gerador fora, 429 no aquecimento, original ilegível), o ouvinte de `error` do
 * `index.html` troca o `src` pelo `data-original`. Ele fica no index, e não no componente, porque
 * no SSR a imagem pode falhar ANTES da hidratação, quando nenhum handler do Angular existe ainda.
 */

/** As larguras que o gerador aceita (`LARGURAS` em aws-sam-imagens/src/imagens.mjs). */
export type LarguraDeImagem = 240 | 640 | 1280;

/** `caminho` é o do original SEM a extensão: `profiles/<hash>`, `products/<hash>/lg_<hash>`. */
export function urlOriginal(caminho: string): string {
	return `${environment.imgURL}/${caminho}.jpg`;
}

export function urlDaVersao(caminho: string, largura: LarguraDeImagem): string {
	const base = environment.imgVariantURL;
	return base ? `${base}/v/${largura}/${caminho}.webp` : urlOriginal(caminho);
}

/** `srcset` com as larguras dadas, ou `null` quando o ambiente não usa versões. */
export function srcsetDaVersao(caminho: string, larguras: LarguraDeImagem[]): string | null {
	if (!environment.imgVariantURL) return null;
	return larguras.map((l) => `${urlDaVersao(caminho, l)} ${l}w`).join(', ');
}

export const caminhoDoLogo = (profilePic: string) => `profiles/${profilePic}`;
export const caminhoDaCapa = (coverPic: string) => `covers/${coverPic}`;
export const caminhoDoDestaque = (imagem: string) => `highlightImages/${imagem}/lg_${imagem}`;
export const caminhoDaFotoGrande = (imagem: string) => `products/${imagem}/lg_${imagem}`;
export const caminhoDaMiniatura = (imagem: string) => `products/${imagem}/thumb_${imagem}`;
